import { render } from "./TableCustomers.vue?vue&type=template&id=09ad775c"
import script from "./TableCustomers.vue?vue&type=script&lang=ts"
export * from "./TableCustomers.vue?vue&type=script&lang=ts"

import "./TableCustomers.vue?vue&type=style&index=0&id=09ad775c&lang=scss"
script.render = render

export default script